import { render } from "./PaymentMethodsSection.vue?vue&type=template&id=1ade7620&scoped=true"
import script from "./PaymentMethodsSection.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsSection.vue?vue&type=script&lang=js"

import "./PaymentMethodsSection.vue?vue&type=style&index=0&id=1ade7620&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ade7620"]])

export default __exports__